// let display = "none"

export const ParentInputs = [
    [
        {
            type: "text",
            name: "firstName",
            label: { ar: "الاسم الاول", en: "First name" },
            placeholder: "",
            size: { lg: "6", md: "6" }
        },
        {
            type: "text",
            name: "lastName",
            label: { ar: "الاسم الاخير", en: "Last name" },
            placeholder: "",
            size: { lg: "6", md: "6" }
        },
        {
            type: "email",
            name: "email",
            label: { ar: "البريد الالكتروني", en: "Email" },
            placeholder: "",
            size: { lg: "6", md: "6" }
        },
        {
            type: "text",
            name: "UserName",
            label: { ar: "اسم المستخدم", en: "Username" },
            placeholder: "",
            size: { lg: "6", md: "6" }
        },
        {
            type: "password",
            label: { ar: "كلمة المرور", en: "Password" },
            placeholder: "**********",
            name: "password",
            size: { lg: "6", md: "6" }
        },
        {
            type: "password",
            label: { ar: 'تأكيد كلمة المرور', en: "Password confirmation" },
            placeholder: "**********",
            name: "confirmpassword",
            size: { lg: "6", md: "6" }
        },
        // {
        //     type: "text",
        //     name: "country",
        //     label: { ar: "الدولة", en: "Country" },
        //     placeholder: "",
        //     size: { lg: "6", md: "6" }
        // },
        // {
        //     type: "text",
        //     name: "city",
        //     label: { ar: "المحافظة", en: "City" },
        //     placeholder: "",
        //     size: { lg: "6", md: "6" }
        // },
        {
            type: "text",
            inputType:"number",
            name: "phone",
            label: { ar: "الهاتف", en: "Phone" },
            placeholder: "",
            size: { lg: "6", md: "6" }
        },
        // {
        //     type: "email",
        //     name: "StudentEmail",
        //     label: { ar: " البريد الالكتروني للطالب", en: "Student email" },
        //     placeholder: "",
        //     size: { lg: "6", md: "6" }
        // },
    ]

];
